import '@styles/app.scss';

import { appData } from '@app/app-data';
import { deobfuscate } from '@app/deobfuscate';
import { initLayout } from '@app/layout';
import { profilePictureFallback } from '@app/profile-picture-fallback';
import { userOnline } from '@app/user-online';

import { deviceDetect } from '@tools/device-detect';
import { initUTMTracking } from '@tools/utm-tracking';

appData();
deviceDetect();
initLayout();
profilePictureFallback();
deobfuscate();
userOnline();
initUTMTracking();
